/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DashboardStackedMonthlyVar
 */
export interface DashboardStackedMonthlyVar {
  /**
   *
   * @type {Date}
   * @memberof DashboardStackedMonthlyVar
   */
  month?: Date;
  /**
   *
   * @type {number}
   * @memberof DashboardStackedMonthlyVar
   */
  performanceValue?: number;
  /**
   *
   * @type {number}
   * @memberof DashboardStackedMonthlyVar
   */
  robustnessValue?: number;
  /**
   *
   * @type {number}
   * @memberof DashboardStackedMonthlyVar
   */
  explainabilityValue?: number;
  /**
   *
   * @type {number}
   * @memberof DashboardStackedMonthlyVar
   */
  fairnessValue?: number;
  /**
   *
   * @type {number}
   * @memberof DashboardStackedMonthlyVar
   */
  total: number;
}

/**
 * Check if a given object implements the DashboardStackedMonthlyVar interface.
 */
export function instanceOfDashboardStackedMonthlyVar(value: object): value is DashboardStackedMonthlyVar {
  if (!('total' in value) || value['total'] === undefined) return false;
  return true;
}

export function DashboardStackedMonthlyVarFromJSON(json: any): DashboardStackedMonthlyVar {
  return DashboardStackedMonthlyVarFromJSONTyped(json, false);
}

export function DashboardStackedMonthlyVarFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DashboardStackedMonthlyVar {
  if (json == null) {
    return json;
  }
  return {
    month: json['month'] == null ? undefined : new Date(json['month']),
    performanceValue: json['performance_value'] == null ? undefined : json['performance_value'],
    robustnessValue: json['robustness_value'] == null ? undefined : json['robustness_value'],
    explainabilityValue: json['explainability_value'] == null ? undefined : json['explainability_value'],
    fairnessValue: json['fairness_value'] == null ? undefined : json['fairness_value'],
    total: json['total'],
  };
}

export function DashboardStackedMonthlyVarToJSON(value?: DashboardStackedMonthlyVar | null): any {
  if (value == null) {
    return value;
  }
  return {
    month: value['month'] == null ? undefined : value['month'].toISOString().substring(0, 10),
    performance_value: value['performanceValue'],
    robustness_value: value['robustnessValue'],
    explainability_value: value['explainabilityValue'],
    fairness_value: value['fairnessValue'],
    total: value['total'],
  };
}
